export default class Billing {
  constructor($module) {
    function newAddress() {
      let $radiosShipping = document.querySelectorAll(
        'input[type=radio][name="ShippingAddressSelection"]'
      );
      let $containerNewShipAddressNames = document.getElementById(
        "ip-contact-information_ship_new-address-names"
      );
      let $containerGuestShipAddress = document.getElementById(
        "ip-contact-information_ship_new-address"
      );

      let $radiosBilling = document.querySelectorAll(
        'input[type=radio][name="BillingAddressSelection"]'
      );
      let $containerNewBillAddress = document.getElementById(
        "ip-contact-information__new-address-billing"
      );

      let containerTypeShipping = "shipping";
      let containerTypeBilling = "billing";

      // caching letiables for required elements
      let $childrenElementsShipping;
      let $childrenElementsBilling;

      // runs on page-load only to setup the correct state.
      toggleChildren($containerNewShipAddressNames, "", containerTypeShipping);
      toggleChildren($containerNewBillAddress, "", containerTypeBilling);

      // Set up change listeners
      $radiosShipping.forEach((radio) => {
        radio.addEventListener("change", function () {
          toggleContainer(
            $containerNewShipAddressNames,
            radio.value,
            containerTypeShipping
          );
          toggleChildren(
            $containerNewShipAddressNames,
            radio.value,
            containerTypeShipping
          );
        });
      });

      $radiosBilling.forEach((radio) => {
        radio.addEventListener("change", function () {
          toggleContainer(
            $containerNewBillAddress,
            radio.value,
            containerTypeBilling
          );
          toggleChildren(
            $containerNewBillAddress,
            radio.value,
            containerTypeBilling
          );
        });
      });

      // show/hide relevant new address container
      function toggleContainer(container, radioValue, containerType) {
        if (containerType === containerTypeShipping) {
          if (radioValue === "UseNew") {
            $containerGuestShipAddress.style.display = "block";
            $containerNewShipAddressNames.style.display = "block";
          } else if (radioValue === "Guest") {
            $containerGuestShipAddress.style.display = "block";
            $containerNewShipAddressNames.style.display = "none";
          } else {
            $containerGuestShipAddress.style.display = "none";
            $containerNewShipAddressNames.style.display = "none";
          }
        } else {
          radioValue === "UseNew"
            ? (container.style.display = "block")
            : (container.style.display = "none");
        }
      }

      // toggle required attributes on elements that have them
      function toggleChildren(container, radioValue, containerType) {
        if (container) {
          if (
            !$childrenElementsShipping &&
            containerType === containerTypeShipping
          ) {
            $childrenElementsShipping = container.querySelectorAll(
              "input[required], select[required]"
            );
          }

          if (
            !$childrenElementsBilling &&
            containerType === containerTypeBilling
          ) {
            $childrenElementsBilling = container.querySelectorAll(
              "input[required], select[required]"
            );
          }

          if (containerType === containerTypeShipping) {
            $childrenElementsShipping.forEach((child) => {
              radioValue === "UseNew"
                ? child.setAttribute("required", "")
                : child.removeAttribute("required");
            });
          }

          if (containerType === containerTypeBilling) {
            $childrenElementsBilling.forEach((child) => {
              radioValue === "UseNew"
                ? child.setAttribute("required", "")
                : child.removeAttribute("required");
            });
          }
        }
      }
    }

    // run function on page load
    window.addEventListener("DOMContentLoaded", () => {
      newAddress();
    });
  }
}
